/*------------------------------------*\
    MODULES
\*------------------------------------*/
import * as basicLightbox from 'basiclightbox'

/*------------------------------------*\
        LIGHTBOX
\*------------------------------------*/
class Lightbox {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.trigger = self.elem.querySelector('[data-lightbox-trigger]');
        self.template = self.elem.querySelector('[data-lightbox-template]');
    }

    init() {
        let self = this;

        self.trigger.addEventListener('click', evt => {
            evt.preventDefault();

            const lightbox = basicLightbox.create(self.template);

            lightbox.show();
        });
    }
}

export default Lightbox;
